import {
  CreateLabelRequest,
  DeleteLabelRequest,
  FetchLabelRequest,
  FetchLabelsRequest,
  UpdateLabelRequest,
} from 'utils/constants/network';
import { callAPI } from 'utils/network';

export const FETCH_LABELS = 'FETCH_LABELS';
export const FETCHED_LABELS = 'FETCHED_LABELS';
export const FETCH_LABELS_ERROR = 'FETCH_LABELS_ERROR';

export const CREATE_LABEL = 'CREATE_LABEL';
export const CREATED_LABEL = 'CREATED_LABEL';
export const CREATE_LABEL_ERROR = 'CREATE_LABEL_ERROR';

export const FETCH_LABEL = 'FETCH_LABEL';
export const FETCH_LABEL_ERROR = 'FETCH_LABEL_ERROR';
export const FETCHED_LABEL = 'FETCHED_LABEL';

export const UPDATE_LABEL = 'UPDATE_LABEL';
export const UPDATE_LABEL_ERROR = 'UPDATE_LABEL_ERROR';
export const UPDATED_LABEL = 'UPDATED_LABEL';

export const DELETE_LABEL = 'DELETE_LABEL';
export const DELETE_LABEL_ERROR = 'DELETE_LABEL_ERROR';
export const DELETED_LABEL = 'DELETED_LABEL';

export const fetchingLabels = () => ({
  type: FETCH_LABELS,
  payload: {},
});

export const fetchLabels = () => dispatch => {
  dispatch(fetchingLabels);
  const apiRequest = FetchLabelsRequest({});
  return callAPI(apiRequest)
    .then(labels => dispatch(fetchedLabels(labels)))
    .catch(e => dispatch(fetchLabelsError(e)));
};

export const fetchLabelsError = e => ({
  type: FETCH_LABELS_ERROR,
  payload: { error: e.message },
});

const fetchedLabels = labels => ({
  type: FETCHED_LABELS,
  payload: {
    labels,
  },
});

export const fetchingLabel = () => ({
  type: FETCH_LABEL,
  payload: {},
});

export const fetchLabel = () => dispatch => {
  dispatch(fetchingLabel);
  const apiRequest = FetchLabelRequest({});
  return callAPI(apiRequest)
    .then(label => dispatch(fetchedLabel(label)))
    .catch(e => dispatch(fetchLabelError(e)));
};

export const fetchLabelError = e => ({
  type: FETCH_LABEL_ERROR,
  payload: { error: e.message },
});

const fetchedLabel = label => ({
  type: FETCHED_LABEL,
  payload: {
    label,
  },
});

export const creatingLabel = () => ({
  type: CREATE_LABEL,
  payload: {},
});

export const createLabel = label => dispatch => {
  dispatch(creatingLabel);
  const apiRequest = CreateLabelRequest(label);
  return callAPI(apiRequest)
    .then(label => dispatch(createdLabel(label)))
    .catch(e => dispatch(createLabelError(e)));
};

export const createLabelError = e => ({
  type: CREATE_LABEL_ERROR,
  payload: { error: e.message },
});

const createdLabel = label => ({
  type: CREATED_LABEL,
  payload: {
    label,
  },
});

// Update

export const updatingLabel = () => ({
  type: UPDATE_LABEL,
  payload: {},
});

export const updateLabel = label => dispatch => {
  dispatch(updatingLabel);
  (async () => {
    try {
      const apiRequest = UpdateLabelRequest(label);
      const newLabel = await callAPI(apiRequest);
      dispatch(updatedLabel(newLabel));
    } catch (e) {
      dispatch(updateLabelError(e));
    }
  })();
};

export const updateLabelError = e => ({
  type: UPDATE_LABEL_ERROR,
  payload: { error: e.message },
});

const updatedLabel = label => ({
  type: UPDATED_LABEL,
  payload: {
    label,
  },
});

// Delete

export const deletingLabel = () => ({
  type: DELETE_LABEL,
  payload: {},
});

export const deleteLabel = label => dispatch => {
  dispatch(deletingLabel);
  (async () => {
    try {
      const apiRequest = DeleteLabelRequest(label);
      await callAPI(apiRequest);
      dispatch(deletedLabel(label));
    } catch (e) {
      dispatch(deleteLabelError(e));
    }
  })();
};

export const deleteLabelError = e => ({
  type: DELETE_LABEL_ERROR,
  payload: { error: e.message },
});

const deletedLabel = () => ({
  type: DELETED_LABEL,
  payload: {},
});



// WEBPACK FOOTER //
// ./src/actions/labels/index.js